import { getRelativePosition } from '.';
import theme from '@streem/ui-react/src/styles/theme';
/**
 *
 * Given an element and its parent element, an array of keyframes is returned
 * which will animate the element from its current position to fill its parent
 * container height.
 *
 * The element will also become centered within its parent container.
 *
 * @param element The element you want to grow to fill the screen
 * @param parentElement The parent element that the element will fill
 */
export function growElementToFillParentContainer(element, parentElement) {
    // returns where element is currently placed relative to parent conatiner
    const { top: currentTop, left: currentLeft, height: currentHeight, width: currentWidth, } = getRelativePosition(element, parentElement);
    const { height: parentHeight, width: parentWidth } = parentElement.getBoundingClientRect();
    // animations will always start from their current height/width/position (absolute)
    // always include a starting keyframe declaring the current position values
    const startingKeyframeBase = {
        overflow: 'hidden',
        height: `${currentHeight}px`,
        width: `${currentWidth}px`,
        top: `${currentTop}px`,
        left: `${currentLeft}px`,
    };
    return [
        {
            ...startingKeyframeBase,
            position: 'absolute',
            transform: `translateX(0%)`,
            backgroundColor: theme.colors.grey90,
        },
        {
            overflow: 'hidden',
            position: 'absolute',
            left: '0px',
            top: '0px',
            height: `${parentHeight}px`,
            width: `${parentWidth}px`,
            backgroundColor: theme.colors.black,
        },
    ];
}
/**
 * Used to animate remote video feed transitions between FACE and WORLD modes.
 */
export const flipAndBlurKeyframes = [
    {
        filter: 'blur(0px)',
        transform: `rotateY(0deg)`,
    },
    {
        filter: 'blur(10px)',
        transform: `rotateY(90deg)`,
    },
    {
        filter: 'blur(0px)',
        transform: 'rotateY(0deg)',
    },
];
/**
 *
 * Given an element and its parent element, an array of keyframes is returned
 * which will animate the element from its current position and anchor it
 * to the bottom right corner of its parent container.
 *
 * @param element
 * @param parentContainerElement
 * @param targetCoords The desired dimensions and right/bottom position of the element after the animation is complete.
 */
export function shrinkElementToBottomRightCornerOfParentContainer(element, parentContainerElement, targetCoords) {
    const { bottom: currentBottom, right: currentRight, height: currentHeight, width: currentWidth, } = getRelativePosition(element, parentContainerElement);
    const startingKeyframeBase = {
        position: 'absolute',
        height: `${currentHeight}px`,
        width: `${currentWidth}px`,
        right: `${currentRight}px`,
        bottom: `${currentBottom}px`,
    };
    return [
        {
            ...startingKeyframeBase,
        },
        {
            position: 'absolute',
            bottom: `${targetCoords.bottom}px`,
            right: `${targetCoords.right}px`,
            height: `${targetCoords.height}px`,
            width: `${targetCoords.width}px`,
        },
    ];
}
/**
 *
 * Given an element and a target element, returns an array of keyframes which
 * will animate the element from its current position to match the target element's
 * height/width and absolute position.
 *
 * Think of it like a lunar eclipse of the target element, and the element being animated is the moon.
 *
 * We use this when re-anchoring the in call 2WV video frames back into the AutoGrid.
 *
 * @param element
 * @param targetElement
 * @param parentContainerElement
 */
export function moveElementToCoverTargetElement(element, targetElement, parentContainerElement) {
    const { top: currentTop, left: currentLeft, height: currentHeight, width: currentWidth, } = getRelativePosition(element, parentContainerElement);
    const { height: targetHeight, width: targetWidth, left: targetLeft, top: targetTop, } = getRelativePosition(targetElement, parentContainerElement);
    const startingKeyframeBase = {
        position: 'absolute',
        height: `${currentHeight}px`,
        width: `${currentWidth}px`,
        left: `${currentLeft}px`,
        top: `${currentTop}px`,
    };
    return [
        {
            ...startingKeyframeBase,
            backgroundColor: theme.colors.black,
        },
        {
            position: 'absolute',
            top: `${targetTop}px`,
            left: `${targetLeft}px`,
            height: `${targetHeight}px`,
            width: `${targetWidth}px`,
            backgroundColor: theme.colors.grey90,
            borderRadius: '20px',
        },
    ];
}
//# sourceMappingURL=transition_keyframes.js.map